// @flow
export const NIQ_SORT_TABLE = 'NIQ_SORT_TABLE'
export const NIQ_UPDATE_AGGREGATION = 'NIQ_UPDATE_AGGREGATION'
export const NIQ_TIME_AGGREGATION_CHANGED = 'NIQ_TIME_AGGREGATION_CHANGED'
export const NIQ_TIME_DIMENSION_CHANGED = 'NIQ_TIME_DIMENSION_CHANGED'
export const NIQ_VIEW_CHANGED = 'NIQ_VIEW_CHANGED'
export const NIQ_DIMENSION_CHANGED = 'NIQ_DIMENSION_CHANGED'
export const NIQ_DESCRIPTION_TAG_FOR_EDIT = 'NIQ_DESCRIPTION_TAG_FOR_EDIT'
export const NIQ_DESCRIPTION_TOGGLE_EDIT = 'NIQ_DESCRIPTION_TOGGLE_EDIT'
export const NIQ_SEARCH_TOGGLE_LOCK_DATA = 'NIQ_SEARCH_TOGGLE_LOCK_DATA'
export const NIQ_BULK_STAGE_DICT_EDITS = 'NIQ_BULK_STAGE_DICT_EDITS'
export const NIQ_BULK_UNSTAGE_DICT_EDITS = 'NIQ_BULK_UNSTAGE_DICT_EDITS'
export const NIQ_STAGE_DICT_EDIT = 'NIQ_STAGE_DICT_EDIT'
export const NIQ_DESCRIPTION_SAVE_EDITS = 'NIQ_DESCRIPTION_SAVE_EDITS'
export const NIQ_DESCRIPTION_SAVE_EDITS_STARTED = 'NIQ_DESCRIPTION_SAVE_EDITS_STARTED'
export const NIQ_DESCRIPTION_SAVE_EDITS_SUCCEEDED = 'NIQ_DESCRIPTION_SAVE_EDITS_SUCCEEDED'
export const NIQ_DESCRIPTION_SAVE_EDITS_FAILED = 'NIQ_DESCRIPTION_SAVE_EDITS_FAILED'
export const NIQ_DESCRIPTION_BRAND_SUGGEST = 'NIQ_DESCRIPTION_BRAND_SUGGEST'
export const NIQ_DESCRIPTION_CATEGORY_SUGGEST = 'NIQ_DESCRIPTION_CATEGORY_SUGGEST'
export const NIQ_DESCRIPTION_BRAND_SUGGEST_SUCCEEDED = 'NIQ_DESCRIPTION_BRAND_SUGGEST_SUCCEEDED'
export const NIQ_DESCRIPTION_SUGGEST_CLEAN = 'NIQ_DESCRIPTION_SUGGEST_CLEAN'
export const NIQ_REMOVE_STAGED_EDIT = 'NIQ_REMOVE_STAGED_EDIT'
export const NIQ_DESCRIPTION_CATEGORY_SUGGEST_SUCCEEDED = 'NIQ_DESCRIPTION_CATEGORY_SUGGEST_SUCCEEDED'
export const NIQ_DESCRIPTION_BRAND_EDIT_SELECT = 'NIQ_DESCRIPTION_BRAND_EDIT_SELECT'
export const NIQ_DESCRIPTION_CATEGORY_EDIT_SELECT = 'NIQ_DESCRIPTION_CATEGORY_EDIT_SELECT'
export const NIQ_DESCRIPTION_EDIT_STATUS_UPDATED = 'NIQ_DESCRIPTION_EDIT_STATUS_UPDATED'
export const NIQ_DESCRIPTION_EDIT_STATUS_UPDATE_FAILED = 'NIQ_DESCRIPTION_EDIT_STATUS_UPDATE_FAILED'
export const NIQ_REFRESH_DESCRIPTION_EDIT_STATUS = 'NIQ_REFRESH_DESCRIPTION_EDIT_STATUS'
export const NIQ_START_LOADING_WHEEL = 'NIQ_START_LOADING_WHEEL'
export const NIQ_SEARCH_FILTER_CHANGED = 'NIQ_SEARCH_FILTER_CHANGED'
export const NIQ_SEARCH_DESCRIPTION_SELECTION_CHANGED = 'NIQ_SEARCH_DESCRIPTION_SELECTION_CHANGED'
export const NIQ_SEARCH_REFRESH_DESCRIPTION_DATA = 'NIQ_SEARCH_REFRESH_DESCRIPTION_DATA'
export const NIQ_CHANGE_TOOLBAR_OPTION = 'NIQ_CHANGE_TOOLBAR_OPTION'
export const NIQ_CHANGE_SEARCH_COLUMNS_VISIBILITY = 'NIQ_CHANGE_SEARCH_COLUMNS_VISIBILITY'
export const NIQ_APPLY_TEMP_FILTER = 'NIQ_APPLY_TEMP_FILTER'
export const NIQ_REMOVE_TEMP_FILTER = 'NIQ_REMOVE_TEMP_FILTER'
export const NIQ_WIDGETS_OPTIONS_CHANGED = 'NIQ_WIDGETS_OPTIONS_CHANGED'
export const NIQ_UPDATE_WIDGET_DATA = 'NIQ_UPDATE_WIDGET_DATA'
export const NIQ_QC_DESCRIPTION_SAVE_EDITS = 'NIQ_QC_DESCRIPTION_SAVE_EDITS'
export const NIQ_QC_DESCRIPTION_SAVE_EDITS_STARTED = 'NIQ_QC_DESCRIPTION_SAVE_EDITS_STARTED'
export const NIQ_QC_DESCRIPTION_SAVE_EDITS_FAILED = 'NIQ_QC_DESCRIPTION_SAVE_EDITS_FAILED'
export const NIQ_REFRESH_QC_DESCRIPTION_EDIT_STATUS = 'NIQ_REFRESH_QC_DESCRIPTION_EDIT_STATUS'
export const NIQ_TOGGLE_WIDGET_ENABLED_STATUS = 'NIQ_TOGGLE_WIDGET_ENABLED_STATUS'
export const NIQ_UPDATE_STATS_DATA = 'NIQ_UPDATE_STATS_DATA'
export const NIQ_TOGGLE_DESCRIPTION_SEARCH_STATUS = 'NIQ_TOGGLE_DESCRIPTION_SEARCH_STATUS'
export const NIQ_TOGGLE_QC_DESCRIPTION_SEARCH_STATUS = 'NIQ_TOGGLE_QC_DESCRIPTION_SEARCH_STATUS'
export const NIQ_FETCH_DESCRIPTION_EDIT_SUGGESTIONS = 'NIQ_FETCH_DESCRIPTION_EDIT_SUGGESTIONS'
export const NIQ_FETCH_DESCRIPTION_EDIT_SUGGESTIONS_SUCCEEDED = 'NIQ_FETCH_DESCRIPTION_EDIT_SUGGESTIONS_SUCCEEDED'
export const NIQ_FETCH_DESCRIPTION_EDIT_SUGGESTIONS_FAILED = 'NIQ_FETCH_DESCRIPTION_EDIT_SUGGESTIONS_FAILED'
export const NIQ_FETCH_QC_DESCRIPTION_EDIT_SUGGESTIONS = 'NIQ_FETCH_QC_DESCRIPTION_EDIT_SUGGESTIONS'
export const NIQ_FETCH_QC_DESCRIPTION_EDIT_SUGGESTIONS_SUCCEEDED = 'NIQ_FETCH_QC_DESCRIPTION_EDIT_SUGGESTIONS_SUCCEEDED'
export const NIQ_FETCH_QC_DESCRIPTION_EDIT_SUGGESTIONS_FAILED = 'NIQ_FETCH_QC_DESCRIPTION_EDIT_SUGGESTIONS_FAILED'

export function onSearchFilterChanged(key, value) {
  return {
    type: NIQ_SEARCH_FILTER_CHANGED,
    key,
    value
  }
}

export function onToggleDescriptionEdit() {
  return {
    type: NIQ_DESCRIPTION_TOGGLE_EDIT
  }
}

export function onToggleSearchLockData() {
  return {
    type: NIQ_SEARCH_TOGGLE_LOCK_DATA
  }
}

export function onTagForEdit(rows, add) {
  return {
    type: NIQ_DESCRIPTION_TAG_FOR_EDIT,
    data: {
      rows,
      add
    }
  }
}

export function onSaveDictionaryEntries() {
  return {
    type: NIQ_DESCRIPTION_SAVE_EDITS
  }
}

export function onSaveQCDictionaryEntries() {
  return {
    type: NIQ_QC_DESCRIPTION_SAVE_EDITS
  }
}

export function onBulkStageDictionaryEdits() {
  return {
    type: NIQ_BULK_STAGE_DICT_EDITS
  }
}

export function onBulkUnstageDictionaryEdits() {
  return {
    type: NIQ_BULK_UNSTAGE_DICT_EDITS
  }
}

/**
 * @param {string} text - the brand name to suggest
 * @param {string} categoryFullPath - the category full path to suggest the brand for
 * @returns {object} - the action object
 */
export function onBrandSuggest(text, categoryFullPath = undefined) {
  return {
    type: NIQ_DESCRIPTION_BRAND_SUGGEST,
    data: {
      text,
      type: 'brand_name',
      categoryFullPath
    }
  }
}

export function onCategorySuggest(text) {
  return {
    type: NIQ_DESCRIPTION_CATEGORY_SUGGEST,
    data: {
      text,
      type: 'category_full_path'
    }
  }
}

export function descriptionSuggestClean() {
  return {
    type: NIQ_DESCRIPTION_SUGGEST_CLEAN
  }
}

export function onBrandEditSelect(data) {
  return {
    type: NIQ_DESCRIPTION_BRAND_EDIT_SELECT,
    data:
      data && data.length
        ? {
            id: data[0].id,
            value: data[0].value
          }
        : null
  }
}

export function onCategoryEditSelect(data) {
  return {
    type: NIQ_DESCRIPTION_CATEGORY_EDIT_SELECT,
    data:
      data && data.length
        ? {
            id: data[0].id,
            value: data[0].value
          }
        : null
  }
}

export function onStartLoadWheel(aggType) {
  return {
    type: NIQ_START_LOADING_WHEEL,
    aggType,
    loading: true
  }
}
export function onDescriptionSelectionChanged(attribute, value) {
  return {
    type: NIQ_SEARCH_DESCRIPTION_SELECTION_CHANGED,
    attribute,
    value
  }
}
export function onTableSort(aggType, sortBy, sortOrder) {
  return {
    type: NIQ_SORT_TABLE,
    data: {
      aggType,
      sortBy,
      sortOrder,
      updateAggs: [aggType]
    }
  }
}

export function onTimeAggregationChanged(aggregation, aggType, selectedFilter, selectedInterval) {
  return {
    type: NIQ_TIME_AGGREGATION_CHANGED,
    data: {
      aggregation,
      selectedFilter,
      selectedInterval,
      aggType,
      updateAggs: [aggType]
    }
  }
}

export function onTimeDimensionChanged(axis, aggregation, aggType) {
  return {
    type: NIQ_TIME_DIMENSION_CHANGED,
    data: {
      axis,
      aggregation,
      aggType,
      updateAggs: [aggType]
    }
  }
}

export function onDimensionChanged(axis, aggType) {
  return {
    type: NIQ_DIMENSION_CHANGED,
    data: {
      axis,
      aggType
    }
  }
}

export function onViewChanged(view, aggType) {
  return {
    type: NIQ_VIEW_CHANGED,
    data: {
      view,
      aggType
    }
  }
}

export function onUpdateAggregation(aggType, aggregationUpdates) {
  return {
    type: NIQ_UPDATE_AGGREGATION,
    data: {
      aggType,
      aggregationUpdates,
      updateAggs: [aggType]
    }
  }
}
export function refreshSearchDescriptionData() {
  return {
    type: NIQ_SEARCH_REFRESH_DESCRIPTION_DATA
  }
}
export function refreshDesciptionEditStatus() {
  return {
    type: NIQ_REFRESH_DESCRIPTION_EDIT_STATUS
  }
}

export function refreshQCDescriptionEditStatus() {
  return {
    type: NIQ_REFRESH_QC_DESCRIPTION_EDIT_STATUS
  }
}

export function stageDictEdit(key, attribute, id, name) {
  return {
    type: NIQ_STAGE_DICT_EDIT,
    key,
    attribute,
    id,
    name
  }
}

export function removeStagedEdit(key, attribute) {
  return {
    type: NIQ_REMOVE_STAGED_EDIT,
    key,
    attribute
  }
}

export function onToggleToolbarOption() {
  return {
    type: NIQ_CHANGE_TOOLBAR_OPTION
  }
}

export function onChangeSearchColumnsVisibility(column) {
  return {
    type: NIQ_CHANGE_SEARCH_COLUMNS_VISIBILITY,
    column
  }
}

export function onRemoveTempFilter(aggType, value) {
  return {
    type: NIQ_REMOVE_TEMP_FILTER,
    aggType,
    value
  }
}

export function onApplyTempFilter(aggType, value) {
  return {
    type: NIQ_APPLY_TEMP_FILTER,
    aggType,
    value
  }
}

export function onWidgetsOptionsChanged(aggType, attribute, value) {
  return {
    type: NIQ_WIDGETS_OPTIONS_CHANGED,
    aggType,
    attribute,
    value
  }
}

export function updateWidgetData(aggType) {
  return {
    type: NIQ_UPDATE_WIDGET_DATA,
    aggType
  }
}

export function onChangeWidgetEnabledStatus(widgetType) {
  return {
    type: NIQ_TOGGLE_WIDGET_ENABLED_STATUS,
    widgetType
  }
}

export function updateStatsData() {
  return {
    type: NIQ_UPDATE_STATS_DATA
  }
}

export function toggleDescriptionSearchStatus() {
  return {
    type: NIQ_TOGGLE_DESCRIPTION_SEARCH_STATUS
  }
}

export function toggleQCDescriptionSearchStatus() {
  return {
    type: NIQ_TOGGLE_QC_DESCRIPTION_SEARCH_STATUS
  }
}

export function fetchDescriptionEditSuggestions() {
  return {
    type: NIQ_FETCH_DESCRIPTION_EDIT_SUGGESTIONS
  }
}

export function fetchQCDescriptionEditSuggestions() {
  return {
    type: NIQ_FETCH_QC_DESCRIPTION_EDIT_SUGGESTIONS
  }
}
